module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noOptions":"No roles available","noResult":"No roles were found"},"de":{"noOptions":"Keine Rollen verfügbar","noResult":"Kein Rollen gefunden"},"fr":{"noOptions":"Aucun rôle disponible","noResult":"Aucun rôle n\u0027a été trouvé"},"it":{"noOptions":"Nessun ruoli disponibile","noResult":"Nessun ruoli è stato trovato"}}')
  delete Component.options._Ctor
}
